import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';

import { CharacteristicsObject } from 'src/app/models/characteristics/characteristics.model';
import { OrdersService, OrderSummary } from 'src/app/services/api/orders/orders.service';
import { CharacteristicsConverter } from 'src/app/services/api/characteristics/characteristics.converter';

@Component({
  selector: 'app-order-details-product',
  templateUrl: './order-details-product.component.html',
  styleUrls: ['./order-details-product.component.css']
})
export class OrderDetailsProductComponent implements OnInit {

  @Input() summary: OrderSummary;
  @Input() params: any;
  @Input() isps: any[];
  characteristics: CharacteristicsObject;


  constructor(private ordersService: OrdersService, private characteristicsConverter: CharacteristicsConverter) {

  }

  ngOnInit() {
    this.getCharacteristics();
  }

  private getCharacteristics(): void {
    this.ordersService.getProductCharacteristics(this.params.map).subscribe(
      (data) => {
        this.characteristics = this.characteristicsConverter.convert(data);
      }
    );
  }
}
